import FormatterPage from './FormatterPage';

export default FormatterPage;